import { useEffect, useState } from 'react';

const useResolveData = <T extends object>(unresolvedData: T | Promise<T>) => {
  const [resolvedData, setResolvedData] = useState<T>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | undefined>();

  useEffect(() => {
    if (unresolvedData instanceof Promise) {
      setLoading(true);

      unresolvedData.then(setResolvedData)
      .catch(setError)
      .finally(() => setLoading(false));
    } else {
      setResolvedData(unresolvedData);
    }
  }, [unresolvedData]);

  return { resolvedData, loading, error };
};

export default useResolveData;
